var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#B4B8CF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 7.33331H8.66667V8.66665H3.33333V10.6666L0 7.99998L3.33333 5.33331V7.33331ZM2.66667 12H4.472C5.24179 12.6789 6.19112 13.1212 7.20608 13.2739C8.22105 13.4267 9.25852 13.2833 10.194 12.861C11.1295 12.4387 11.9233 11.7554 12.48 10.8932C13.0368 10.031 13.333 9.02637 13.333 7.99998C13.333 6.97359 13.0368 5.96901 12.48 5.10677C11.9233 4.24453 11.1295 3.56127 10.194 3.13898C9.25852 2.71669 8.22105 2.5733 7.20608 2.72602C6.19112 2.87874 5.24179 3.32109 4.472 3.99998H2.66667C3.28711 3.17143 4.09222 2.49899 5.01805 2.03608C5.94387 1.57316 6.9649 1.33254 8 1.33331C11.682 1.33331 14.6667 4.31798 14.6667 7.99998C14.6667 11.682 11.682 14.6666 8 14.6666C6.9649 14.6674 5.94387 14.4268 5.01805 13.9639C4.09222 13.501 3.28711 12.8285 2.66667 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.938d505f9a38bb95584fc12979c94c48.svg";
export { ForwardRef as ReactComponent };